module.exports = __webpack_public_path__ + "static/img/M7s.efca881f.png";